import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function agregarConfiguracionTBAI (data = {}, params) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(mock.getLanguages.data)
      }, 500)
    })
  } else {
    const req = {
      url: '/api/ticketbai/altaEmpresaTBAI',
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      },
      params,
      data
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { agregarConfiguracionTBAI }
